<template>
    <div class="allType">
        <Header title="全部分类" v-if="!isWx" />
        <!-- 频道 -->
        <div class="par-two allType_head" :style="{'top': isWx?0:'60px'}">
            <div class="home-title-div">
                <ul class="home-title">
                    <li 
                        v-for="(item, index) in typeList" 
                        :key="item.catid" 
                        :class="{'home-title-li': tabIndex === index}"
                        @click="checkTab(index, item)"
                    >
                        <a>{{item.name}}</a>
                        <i :class="{'active': tabIndex === index}"></i>
                    </li>
                </ul>
                <i class="home-yiying"></i>
            </div>
        </div>
        <!-- 对应内容 -->
        <div class="listBox" :style="{'padding-top': isWx?'60px':'120px'}">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="initTypeList"
                :immediate-check="true"
            >
                <van-cell v-for="item in listData" :key="item.id">
                    <div 
                        :class="['item', 'b_img', item.card_type === 1 ? 'flex justify-bet' : '']"
                        @click="jumpPage(item.share_url)"
                    >
                        <div :class="['info', item.card_type === 1 ? 'flex_1 flex justify-bet flex-column' : '']">
                            <p class="title van-multi-ellipsis--l2">{{item.title}}</p>
                            <div v-if="item.card_type === 1" class="option flex align-center mt12">
                                <div class="userBox flex align-center">
                                    <img :src="item.user.image" alt="">
                                    <span>{{item.user.nickname}}</span>
                                </div>
                                <span class="time">{{item.published_des}}</span>
                            </div>
                        </div>
                        <van-image
                            lazy-load
                            fit="cover"
                            width="120"
                            height="80"
                            :src="item.image"
                            v-if="item.card_type === 1"
                        />
                        <!-- 大图 -->
                        <div v-if="item.card_type === 2" class="imgBox mt12">
                            <van-image
                                lazy-load
                                fit="cover"
                                width="100%"
                                height="100%"
                                :src="item.image"
                            />
                            <i class="playBtn" v-if="item.type == 4"></i>
                            <span class="yugao" v-if="item.status == 1">预告</span>
                            <span class="living" v-if="item.status == 2">直播中</span>
                            <span class="huigu" v-if="item.status == 3">回顾</span>
                        </div>
                        <!-- 三图 -->
                        <div v-if="item.card_type === 3" class="imgBox mt12">
                            <van-image 
                                lazy-load 
                                fit="cover" 
                                class="img" 
                                v-for="(elem, index) in item.images"
                                :key="index"
                                :src="elem" 
                            />
                            <span v-if="item.images.length > 3" class="count">5图</span>
                        </div>
                        <div v-if="!(item.card_type === 1)" class="option flex align-center mt12">
                            <div class="userBox flex align-center">
                                <img :src="item.user.image" alt="">
                                <span>{{item.user.nickname}}</span>
                            </div>
                            <span class="time">{{item.published_des}}</span>
                        </div>
                    </div>
                </van-cell>
            </van-list>
        </div>
    </div>
</template>

<script>
import { getDyAllType } from "@/request/api";
import { InfoList, Header } from '@/components'
import { checkWx, navigate } from '@/pages/index/custom'

export default {
    components: {
        Header,
    },
    data() {
        return {
            typeList: [],
            tabIndex: 0,
            catid: '',
            // 列表内容
            listData: [],
            listPage: 1,
            loading: false, // 加载中
            finished: false, // 加载完毕
            isWx: true
        }
    },
    methods: {
        // 获取栏目
        initTypeList() {
            getDyAllType({
                catid: this.catid,
                page: this.listPage,
                pcount: 10,
            }).then( res => {
                let {category, data, error_code} = res;
                if(error_code === 0) {
                    if(this.typeList.length <= 0) {
                        this.typeList = category;
                    }
                    if (data.length === 0 || !data) {
                        this.finished = true;
                        return false;
                    }
                    data.map(item => this.listData.push(item));
                    this.listPage++;
                    this.loading = false;
                }
            }).catch( error => {
                console.log(error)
            })
        },
        // tab切换
        checkTab(index, item) {
            this.listData = [],
            this.listPage = 1,
            this.loading = true,
            this.catid = item.catid;
            this.tabIndex = index;
            this.initTypeList();
        },
        // 页面跳转
        jumpPage(url) {
            navigate('', url)
        }
    },
    created() {
        this.isWx = checkWx();
        // this.initTypeList();
    }
}
</script>


<style lang="less" scoped>
.home-title{
    li {
        position: relative;
        i.active {
            position: absolute;
            width:20px;
            height:4px;
            background:rgba(255,76,103,1);
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 10px;
        }
    }
}
.userBox {
    height: 1.5rem;
    line-height: 1.5rem;
    img {
        width: 1.5rem;
        height: 24px;
        object-fit: cover;
        border-radius: 50%;
        display: block;
        overflow: hidden;
    }
    span {
        font-size:12px;
        font-weight:400;
        color:rgba(34,34,34,1);
        margin: 0 6px;
    }
}
.listBox {
    box-sizing: border-box;
    padding: 0 20px;
    .pr12 {
        padding-right: 0.75rem;
    }
    .mt8 {
        margin-top: 0.5rem !important;
    }
    .mt12 {
        margin-top: .75rem !important;
    }
    .item {
        border-bottom: 1px solid #eee;
    }
    .s_img {
        padding: 20px 0;
        box-sizing: border-box;
        .info {
            box-sizing: border-box;
            padding-right: .75rem;
        }
        .title {
            font-size: 18px;
            font-weight: 500;
            color: rgba(34, 34, 34, 1);
            line-height: 25px;
        }
    }
    .b_img {
        box-sizing: border-box;
        padding: 20px 0;
        .living {
            position: absolute;
            top: .75rem;
            right: .75rem;
            height: 20px;
            line-height: 20px;
            padding-right: 8px;
            padding-left: 22px;
            background: url(../../../../assets/img/ic_live_s.png) no-repeat 8px center;
            background-size: 12px 12px;
            background-color: #FF4C67;
            font-size:12px;
            font-weight:400;
            color:rgba(255,255,255,1);
            border-radius: 2px;
        }
        .huigu {
            position: absolute;
            top: .75rem;
            right: .75rem;
            height: 20px;
            line-height: 20px;
            padding: 0 8px;
            background-color: #00C5AA;
            font-size:12px;
            font-weight:400;
            color:rgba(255,255,255,1);
            border-radius: 2px;
            text-align: center;
        }
        .yugao {
            position: absolute;
            top: .75rem;
            right: .75rem;
            height: 20px;
            line-height: 20px;
            padding: 0 8px;
            background-color: #2E8CFF;
            font-size:12px;
            font-weight:400;
            color:rgba(255,255,255,1);
            border-radius: 2px;
            text-align: center;
        }
        .playBtn {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -1.75rem;
            margin-top: -1.75rem;
            width: 3.5rem;
            height: 3.5rem;
            background: url(../../../../assets/img/ic_playBtn.png) no-repeat;
            background-size: 100% 100%;
        }
        .liveBtn {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -1.75rem;
            margin-top: -1.75rem;
            width: 3.5rem;
            height: 3.5rem;
            background: url(../../../../assets/img/ic_live_b.png) no-repeat;
            background-size: 100% 100%;
        }
        .title {
            font-size: 18px;
            font-weight: 500;
            color: rgba(34, 34, 34, 1);
            line-height: 25px;
        }
        .imgBox {
            width: 100%;
            height: 11.75rem;
            border-radius: 6px;
            overflow: hidden;
            position: relative;
        }
        .imgBoxs {
            width: 100%;
            border-radius: 6px;
            overflow: hidden;
            position: relative;
            .img {
                float: left;
                width: 32.8%;
                height: 4.625rem;
            }
            &>.img:nth-child(2) {
                margin: 0 0.8%;
            }
            .count {
                position: absolute;
                right: .5rem;
                bottom: .5rem;
                width: auto;
                height: 1.25rem;
                line-height: 1.25rem;
                padding: 0 .5rem;
                font-size:12px;
                font-weight:400;
                color:rgba(255,255,255,1);
                border-radius:100px;
                background-color: rgba(0,0,0,.7);
            }
        }
    }
    .option {
        margin: 0;
        .else {
            width: 32px;
            height: 21px;
            margin-right: 4px;
            text-align: center;
            line-height: 21px;
            font-size: 9px;
            font-weight: 400;
            transform: scale(0.75);
            border-radius: 2px;
        }
        .time {
            font-size: 12px;
            font-weight: 400;
            color: rgba(167, 167, 167, 1);
            line-height: 21px;
        }
    }
}
.allType_head {
    position: fixed;
    left: 0;
    width: 100%;
    height: auto;
    background-color: #fff;
    z-index: 999;
}
</style>